import { RegistrationContext, RegistrationField } from "./types";
import { registrationRules } from "./rules";

export const resolveMissingFields = (ctx: RegistrationContext): RegistrationField[] => {
  const seen = new Set<string>();
  const missing: RegistrationField[] = [];

  registrationRules.forEach((rule) => {
    if (rule.phase !== ctx.phase || !rule.matches(ctx)) return;
    rule.fields.forEach((field) => {
      if (seen.has(field.id) || !field.isMissing(ctx)) return;
      seen.add(field.id);
      missing.push(field);
    });
  });

  return missing;
};

/** Union of missing fields across every level the user just chose. */
export const resolveMissingFieldsForLevels = (
  ctx: Omit<RegistrationContext, "level">,
  levels: string[],
): RegistrationField[] => {
  if (levels.length === 0) {
    return resolveMissingFields(ctx);
  }

  const seen = new Set<string>();
  const missing: RegistrationField[] = [];
  levels.forEach((level) => {
    resolveMissingFields({ ...ctx, level }).forEach((field) => {
      if (seen.has(field.id)) return;
      seen.add(field.id);
      missing.push(field);
    });
  });
  return missing;
};
